import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from '@mui/material';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';

const ViewShipmentHeader = ({
  onAcceptClick,
  onRejectClick,
  showAcceptButton,
  showRejectButton,
}) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));
  return (
    <Stack
      alignItems="start"
      direction={{ sm: 'row', xs: 'column' }}
      justifyContent="space-between"
    >
      {isMobile && <Divider sx={{ mb: 2, ml: -2, mt: 3, width: `calc(100% + 32px)` }} />}
      <Stack
        direction="row"
        justifyContent="center"
        spacing={2}
        sx={{ width: { sm: 'max-content', xs: '100%' } }}
      >
        {showRejectButton && (
          <Button onClick={onRejectClick} sx={{ flex: 1 }} variant="outlined">
            Reject {!isMobile && 'Shipment'}
          </Button>
        )}
        {showAcceptButton && (
          <Button onClick={onAcceptClick} sx={{ flex: 1 }}>
            Accept {!isMobile && 'Shipment'}
          </Button>
        )}
      </Stack>
    </Stack>
  );
};

ViewShipmentHeader.propTypes = {
  fromPage: PropTypes.shape({}),
  onAcceptClick: PropTypes.func.isRequired,
  onRejectClick: PropTypes.func.isRequired,
  showAcceptButton: PropTypes.bool.isRequired,
  showRejectButton: PropTypes.bool.isRequired,
};

ViewShipmentHeader.defaultProps = {
  fromPage: null,
};

export default ViewShipmentHeader;
